import { cx } from '@linaria/atomic';
import { Label } from '../atoms/label.component';
import { NonFloatingLabelStyles } from './non-floating-label.styles';
import { NonFloatingLabelProps } from './types';

export const NonFloatingLabel = ({ children, className, disabled, hasError, ...rest }: NonFloatingLabelProps) => {
  const labelClassName = NonFloatingLabelStyles.nonFloatingLabel({ disabled, hasError });

  return (
    <Label className={cx(labelClassName, className)} {...rest}>
      <>{children}</>
    </Label>
  );
};
